<app-loader *ngIf="updateServiceFunctionLoading"></app-loader>
<div class="modal__header">
  <span class="title">Редактирование служебной функции</span>
  <div class="modal-close color-gray-dark" id="appServiceFunctionClose" (click)="onCloseServiceFunctionEditModal()"></div>
</div>
<div class="modal__body">
  <form [formGroup]="editServiceFunctionForm">
    <div class="grid">
      <div class="grid__box grid__box--size-3">
        <div class="title title--s title--vertical title--required">Название</div>
      </div>
      <div class="grid__box grid__box--size-9">
        <app-field>
          <input class="input-text" type="text" id="serviceFunctionName" formControlName="service_function_name" />
        </app-field>
      </div>
    </div>
    <div class="grid mt-16">
      <div class="grid__box grid__box--size-3">
        <div class="title title--s title--vertical title--required">Описание</div>
      </div>
      <div class="grid__box grid__box--size-9">
        <app-field>
          <textarea class="input-textarea" cols="" rows="5" id="desctiption" formControlName="description"></textarea>
        </app-field>
      </div>
    </div>
    <div class="grid mt-16">
      <div class="grid__box grid__box--size-3">
        <div class="title title--s">Отображение в системе</div>
      </div>
      <div class="grid__box grid__box--size-9">
        <span *ngIf="currentSelectedFunction.is_visible === 1">Включено</span>
        <span *ngIf="currentSelectedFunction.is_visible === 0">Отключено</span>
      </div>
    </div>
    <div class="delimiter delimiter--gray-bright delimiter--size-1 mt-24 mb-24"></div>
    <div class="grid grid--va-middle mt-16">
      <div class="grid__box grid__box--size-3">
        <div class="title title--s">Дата создания</div>
      </div>
      <div class="grid__box grid__box--size-9">
        <div *ngIf="currentSelectedFunction.create_date">
          {{ currentSelectedFunction.create_date | dateFormat: 'DD MMMM YYYY г. HH:mm' }}
        </div>
        <div *ngIf="!currentSelectedFunction.create_date" class="mdash"></div>
      </div>
    </div>
    <div class="grid grid--va-middle mt-16">
      <div class="grid__box grid__box--size-3">
        <div class="title title--s">Дата изменения</div>
      </div>
      <div class="grid__box grid__box--size-9">
        <div *ngIf="currentSelectedFunction.update_date">
          {{ currentSelectedFunction.update_date | dateFormat: 'DD MMMM YYYY г. HH:mm' }}
        </div>
        <div *ngIf="!currentSelectedFunction.update_date" class="mdash"></div>
      </div>
    </div>
    <div class="grid grid--va-middle mt-16">
      <div class="grid__box grid__box--size-3">
        <div class="title title--s">Создал</div>
      </div>
      <div class="grid__box grid__box--size-9">
        {{ currentSelectedFunction.created_by_user }}
        <div *ngIf="!currentSelectedFunction.created_by_user" class="mdash"></div>
      </div>
    </div>
    <div class="grid grid--va-middle mt-16">
      <div class="grid__box grid__box--size-3">
        <div class="title title--s">Изменил</div>
      </div>
      <div class="grid__box grid__box--size-9">
        {{ currentSelectedFunction.updated_by_user }}
        <div *ngIf="!currentSelectedFunction.updated_by_user" class="mdash"></div>
      </div>
    </div>
    <div class="grid mt-16">
      <div class="grid__box grid__box--size-3">
        <div class="title title--s" [ngClass]="{ 'title--vertical': versions.length !== 1 }">Версия</div>
      </div>
      <div class="grid__box grid__box--size-2">
        <app-select
          [items]="versions"
          (callback)="onChangeFunctionVersion($event)"
          [textKey]="''"
          [defaultText]="''"
          [initBy]="currentSelectedFunction.version_number"
          [name]="'serviceFunctionNumber'"
          *ngIf="versions.length > 1"
        ></app-select>
        <span *ngIf="versions.length == 1">{{ currentSelectedFunction.version_number }}</span>
      </div>
    </div>
    <div class="mt-16" *ngIf="needRequiredFieldError">
      <app-message [type]="'error'">
        <div message-content>
          Не заполнены или заполнены с ошибками поля:<br />
          <span class="mdash"></span> Название<br />
          <span class="mdash"></span> Описание
        </div>
      </app-message>
    </div>
    <div class="mt-16" *ngIf="backendError">
      <app-message [type]="'error'">
        <div message-content>Не удалось сохранить запись. Повторите попытку через некоторое время. При повторении ошибки свяжитесь с техподдержкой системы.</div>
      </app-message>
    </div>
  </form>
</div>
<div class="modal__footer">
  <div class="modal__footer-action">
    <button class="button" type="button" id="appServiceFunctionSubmit" (click)="onSubmitEditServiceFunctionForm()">Сохранить</button>
  </div>
  <div class="modal__footer-action">
    <a class="link link--dotted-blue-dark" id="appServiceFunctionClose" (click)="onCloseServiceFunctionEditModal()"> Отмена </a>
  </div>
</div>
